module.exports = require("./ki-KE");